import React, { useEffect, useRef, useState } from 'react';
import 'mathlive';
import { MdClose, MdCheck } from 'react-icons/md';

const VisualMathModal = ({ isOpen, onClose, onInsert }) => {
  const mfRef = useRef(null);
  const [latex, setLatex] = useState('');

  useEffect(() => {
    // When modal opens, focus the math field
    if (isOpen && mfRef.current) {
      setTimeout(() => {
        mfRef.current.focus();
      }, 100);
    } else {
      setLatex(''); // Reset when closed
    }
  }, [isOpen]);

  // Handle MathLive input
  useEffect(() => {
    const mf = mfRef.current;
    if (!mf) return;

    const handleInput = (ev) => {
      setLatex(mf.value);
    };

    mf.addEventListener('input', handleInput);
    return () => {
      mf.removeEventListener('input', handleInput);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
        
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gray-50">
          <h2 className="text-lg font-bold text-gray-800">Visual Math Editor</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-red-500 hover:bg-red-50 p-2 rounded-full transition-colors"
          >
            <MdClose size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 flex-1 overflow-y-auto">
          <p className="text-sm text-gray-600 mb-4">
            Use the virtual keyboard below to build your formula. When you are done, click "Insert" to add it to your text.
          </p>

          <div className="border-2 border-indigo-200 rounded-xl overflow-hidden bg-white min-h-[100px] flex items-center p-4">
            <math-field 
              ref={mfRef} 
              style={{ width: '100%', fontSize: '1.5rem', outline: 'none' }}
            >
              {latex}
            </math-field>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2.5 rounded-xl text-sm font-bold text-gray-600 bg-white border border-gray-300 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onInsert(`$${latex}$`);
              onClose();
            }}
            disabled={!latex.trim()}
            className="px-5 py-2.5 rounded-xl text-sm font-bold text-white bg-indigo-600 hover:bg-indigo-700 transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <MdCheck size={18} />
            Insert Math
          </button>
        </div>

      </div>
    </div>
  );
};

export default VisualMathModal;
